(() => {
  const revealItems = document.querySelectorAll('.stondon-reveal:not(.is-visible)');
  if (revealItems.length) {
    revealItems.forEach((item, index) => {
      item.style.setProperty('--stondon-reveal-delay', `${Math.min(index % 4, 3) * 55}ms`);
    });

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

      revealItems.forEach((item) => observer.observe(item));
    }
  }

  document.querySelectorAll('[data-stondon-compare-tools]').forEach((toolbar) => {
    if (toolbar.dataset.initialized === 'true') return;
    toolbar.dataset.initialized = 'true';

    const table = toolbar.nextElementSibling?.querySelector('.stondon-table');
    const rows = table ? Array.from(table.querySelectorAll('tbody tr')) : [];
    const status = toolbar.querySelector('.stondon-compare-tools__status');

    toolbar.querySelectorAll('[data-stondon-compare]').forEach((button) => {
      button.addEventListener('click', () => {
        const differentOnly = button.dataset.stondonCompare === 'different';
        toolbar.querySelectorAll('[data-stondon-compare]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });

        let visibleRows = 0;
        rows.forEach((row) => {
          row.hidden = differentOnly && row.dataset.stondonMatch === 'true';
          if (!row.hidden) visibleRows += 1;
        });
        if (status) status.textContent = `${visibleRows} specifications shown`;
      });
    });
  });

  document.querySelectorAll('.stondon-accordion').forEach((group) => {
    group.addEventListener('toggle', (event) => {
      const opened = event.target;
      if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
      group.querySelectorAll('details[open]').forEach((item) => {
        if (item !== opened) item.open = false;
      });
    }, true);
  });
})();
